import { useState, useEffect } from 'react';
import { isBrowser } from '@/utils/platform';

const useResize = () => {
  const [size, setSize] = useState({
    width: isBrowser ? window?.innerWidth : 0,
    height: isBrowser ? window?.innerHeight : 0,
  });

  useEffect(() => {
    window?.addEventListener('resize', handleResize);
    return () => window?.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setSize({
      width: window?.innerWidth,
      height: window?.innerHeight,
    });
  };

  return size;
};

export default useResize;
